import { Component, EventEmitter, Input, Output } from '@angular/core';

export interface ParticipantSorting {
  field:
    | 'none'
    | 'name'
    | 'status'
    | 'organization'
    | 'role'
    | 'comments'
    | 'ideas';
  dir: 'asc' | 'desc';
}

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'participant-bar-control',
  templateUrl: './participant-bar-control.component.html',
  styleUrls: ['./participant-bar-control.component.scss'],
})
export class ParticipantBarControlComponent {
  @Input() sorting: ParticipantSorting = {
    field: 'role',
    dir: 'desc',
  };
  @Output() sortingChanged = new EventEmitter<ParticipantSorting>();

  setSort(field) {
    if (this.sorting.field === field) {
      this.sorting.dir = this.sorting.dir === 'asc' ? 'desc' : 'asc';
    } else {
      this.sorting.field = field;
      this.sorting.dir = 'desc';
    }

    this.sortingChanged.emit(this.sorting);
  }
}
